import { render, staticRenderFns } from "./AddParticipantsInEdit.vue?vue&type=template&id=1cffad7e"
import script from "./AddParticipantsInEdit.vue?vue&type=script&lang=js"
export * from "./AddParticipantsInEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports